import calculatePA from './CalculatePA';
import calculatePE from './CalculatePE';
import { jaccardWeight } from './WeightFunctions';

function calculateInterCoder(overlappingExcerpts, weightFn = jaccardWeight) {
    const pa = calculatePA(overlappingExcerpts, weightFn);
    const pe = calculatePE(overlappingExcerpts, weightFn);
    return Number(((pa - pe) / (1 - pe)).toFixed(3));
}

export default calculateInterCoder;
